import React from "react";

/**
 * Grain — an SVG paper-grain overlay applied to ivory / cream sections.
 * Ultra-subtle (opacity ~4%) — invisible individually, tactile in aggregate.
 * Absolutely positioned; pointer-events none.
 */
export default function Grain({ opacity = 0.045, className = "" }) {
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'>
    <filter id='n'>
      <feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/>
      <feColorMatrix values='0 0 0 0 0.07  0 0 0 0 0.07  0 0 0 0 0.06  0 0 0 1 0'/>
    </filter>
    <rect width='100%' height='100%' filter='url(%23n)'/>
  </svg>`;
  const dataUri = `url("data:image/svg+xml;utf8,${svg.replace(/\s+/g, " ")}")`;
  return (
    <div
      aria-hidden
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={{
        backgroundImage: dataUri,
        backgroundRepeat: "repeat",
        opacity,
        mixBlendMode: "multiply",
      }}
    />
  );
}
